var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ru:alert",class:_vm.classes},[(_vm.icon)?_c('svg',{staticClass:"ru:alert__icon",attrs:{"viewBox":"0 0 24 24"}},[_c('use',_vm._b({},'use',{
        'xlink:href': `${require('~/assets/svg/ru-icons.svg')}#${_vm.icon}`,
      },false))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"ru:alert__text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }